import RoleHome from '../RoleHome';

export default function SystemAdminPage() {
  return (
    <RoleHome
      title="System admin"
      description="Users, facilities, queues, audit logs, and cross‑module administration."
    />
  );
}
